exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".files-grid-row {\n  flex-direction: column !important;\n}\n\n@media only screen and (min-width: 600px) {\n  .files-grid-row {\n    flex-direction: row !important;\n  }\n}\n\n@media only screen and (min-width: 600px) {\n  .switch-view, .folder-list {\n    width: 18.75% !important;\n  }\n}\n", ""]);

// exports
